// extracted by mini-css-extract-plugin
export default {"card5":"RuDG6Rz4","image":"BrKrc60f","content":"PsiAk5yW","quote":"TqtYBpGM"};